import React from "react";

import { safeParseISO } from "@utils/date";
import { isDefined } from "@utils/helpers";

import {
    ProductPromotion,
    SalesIncentive,
} from "lib/@types/service/product/shared";

import { PromotionPeriodComponent } from "./promotionPeriod.component";

type PromotionPeriodProps = {
    salesIncentives: Array<SalesIncentive>;
    promotions: Array<ProductPromotion>;
    className?: string;
};

const PromotionPeriod = ({
    salesIncentives,
    promotions,
    className,
}: PromotionPeriodProps) => {
    const highestOrderSalesIncentiveType = salesIncentives
        .sort(
            (salesIncentive1, salesIncentive2) =>
                salesIncentive1.order - salesIncentive2.order,
        )
        .at(0)?.type;

    const highestOrderPromotion = promotions.find(
        ({ promotionType }) => promotionType === highestOrderSalesIncentiveType,
    );

    const validFrom = safeParseISO(highestOrderPromotion?.validFrom);
    const validTo = safeParseISO(highestOrderPromotion?.validTo);

    if (!isDefined(validTo)) {
        return null;
    }

    return (
        <PromotionPeriodComponent
            className={className}
            validFrom={validFrom}
            validTo={validTo}
            periodText={highestOrderPromotion?.periodText}
        />
    );
};

export { PromotionPeriod };
